<script setup>
import { slugify } from '#common/utils/slugify'

const props = defineProps({
  item: {
    type: Object,
    required: true,
  },
  useAllRegions: {
    type: Boolean,
    default: false,
  },
})
const emit = defineEmits(['change'])
const metadata = useMetadata()
const manuallyExpanded = ref(undefined)

const slugId = computed(() => {
  return (
    'region-' + (props.item.slug || slugify(props.item.chipName.toLowerCase()))
  )
})
const showSubmenu = computed(() => {
  return props.item.regions && Object.keys(props.item.regions).length > 0
})
const expanded = computed(() => {
  return manuallyExpanded.value === undefined
    ? props.item.checked
    : manuallyExpanded.value
})

function handleCheckbox() {
  const action = `${props.item.checked ? 'deselect' : 'select'}${
    props.useAllRegions ? 'All' : ''
  }Region`
  if (props.useAllRegions) {
    if (props.item.checked) {
      $store.dispatch(action, { region: props.item })
    } else {
      $store.dispatch(action, { region: props.item })
    }
  } else {
    if (props.item.checked) {
      metadata.deselectRegion({ region: props.item })
    } else {
      metadata.selectRegion({ region: props.item })
    }
  }
  emit('change')
}
function toggleExpanded() {
  manuallyExpanded.value = !manuallyExpanded.value
}
</script>

<template>
  <li>
    <input
      :id="slugId"
      type="checkbox"
      :checked="item.checked"
      @input="handleCheckbox"
    />
    <label :for="slugId">
      {{ item.name }}
    </label>
    <button
      v-if="showSubmenu"
      :class="expanded ? 'regions-collapse' : 'regions-expand'"
      @click="toggleExpanded"
    >
      <span v-if="!expanded" class="sr-only">Show More</span>
      <span v-else class="sr-only">Show Less</span>
    </button>
    <ul v-if="showSubmenu && expanded" class="subregion">
      <RegionsFilterItem
        v-for="region of item.regions"
        :key="region.slug"
        :item="region"
        :use-all-regions="useAllRegions"
        @change="$emit('change')"
      />
    </ul>
  </li>
</template>
